module.exports = __webpack_public_path__ + "static/media/icomoon.21d45cbe.svg";